/**
 * Created by JackCui on 2022/10/24
 */

/**
 * 关系相关属性方法 (需实现)
 *  追加节点, 建立节点间关系 (节点不存在即添加, 存在则更新)
 *  节点状态 not_update (兼容修改字段后不再更新)
 *  获取节点
 *  触发节点更新, 同步递归更新子节点
 */

const NODE_STATUS = {
  ACTIVE: 'active',
  CANCEL: 'cancel'
}

class processRelate {
  constructor () {
    this.nodeMap = {}
  }

  reset () {
    this.nodeMap = {}
  }

  /**
   * 生成 _id
   * @param objectApiName
   * @param fieldApiName
   * @param rowId 从对象行的唯一ID
   * @param suffix 唯一的特殊后缀
   * @returns {string}
   */
  nodeId ({objectApiName, fieldApiName, rowId, suffix}) {
    const _ids = [objectApiName, fieldApiName, rowId, suffix]
    return _ids.filter(v => v).join('_')
  }

  getNodes ({objectApiName}) {
    if (!this.nodeMap?.[objectApiName]) {
      this.nodeMap[objectApiName] = []
    }

    return this.nodeMap?.[objectApiName]
  }

  _checkNode (node) {
    const _id = this.nodeId(node)
    return this.getNodes(node).find(n => n._id === _id)
  }

  // 创建节点
  _creatNode (node) {
    const _ = this._checkNode(node)
    let _node

    if (!_) {
      _node = {
        _id: this.nodeId(node),
        handler () {
        },
        value: '',
        ...node,
        status: NODE_STATUS.ACTIVE,
        children: []
      }
    } else {
      return Object.assign(_, node)
    }

    this.getNodes(node).push(_node)
    return _node
  }

  updateNode (node, options) {
    const _node = this._checkNode(node)
    Object.assign(_node, options)
  }

  cancelNode (node) {
    this.updateNode(node, {status: NODE_STATUS.CANCEL})
  }

  // 获取节点
  getNode (node) {
    const _node = this._checkNode(node)

    if (_node) {
      return Object.assign(_node, node)
    } else {
      return this._creatNode(node)
    }
  }

  // 增加关联关系
  creatRelate (a, b) {
    const _a = this.getNode(a)
    const _b = this.getNode(b)
    // 建立关系前先查看当前节点内有无重复
    const inChildrenIdx = _a.children.findIndex(v => v._id === _b._id)
    inChildrenIdx >= 0
      ? Object.assign(_a.children[inChildrenIdx], _b)
      : _a.children.push(_b)
  }

  // 触发节点
  async triggerNodes (params) {
    const _id = this.nodeId(params)
    const _node = this.getNodes(params).find(n => n._id === _id)

    if (!_node) {
      console.log('暂无此节点!' + _id)
      this.getNode(params)
      return
    }

    // 更新当前父节点
    this.updateNode(_node, params)

    const _children = []
    const {children} = _node
    for (let i = 0; i < children.length; i++) {
      const childNode = children[i]

      if (childNode.status === NODE_STATUS.ACTIVE && childNode.handler) {
        await childNode.handler.call(null, childNode, _node)
      }

      childNode.children.length && _children.push(childNode)
    }

    if (_children.length) {
      _children.forEach(node => {
        this.triggerNodes(node)
      })
    }
  }
}

export default new processRelate()
